import { getUserType } from './auth';

var host = process.env.REACT_APP_BASE_URL;

export default host;

export const getLink = (link, tipo = null) => {
  if (link && link[0] === '/') {
    link = link.substring(1);
  }
  const userType = getUserType(tipo);
  return `${process.env.PUBLIC_URL}/${userType}/${link}`;
};
